import React from 'react';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { OFFLINE_PUNCH_DELETE_CONFIRM_MESSAGE } from '../constants/offlinePunchLabels';

function OfflinePunchDeleteConfirmAlert({
  id,
  isDeleting = false,
  onCancel,
  onConfirm,
  open = false,
}) {
  const theme = useTheme();
  const listPadding = theme.spacing(3);
  const currentFontWeight = Number(theme.typography.button.fontWeight);
  const buttonFontWeight =
    (Number.isFinite(currentFontWeight) ? currentFontWeight : 400) + 100;

  return (
    <Collapse
      in={open}
      timeout="auto"
      unmountOnExit
      sx={{
        ml: `-${listPadding}`,
        width: `calc(100% + ${listPadding})`,
      }}
    >
      <Alert
        action={
          <Stack alignItems="center" direction="column">
            <Button
              color="inherit"
              disabled={isDeleting}
              id={`${id}__yes`}
              onClick={onConfirm}
              size="medium"
              sx={{ fontWeight: buttonFontWeight }}
              type="button"
              variant="text"
            >
              YES
            </Button>
            <Button
              color="inherit"
              disabled={isDeleting}
              id={`${id}__no`}
              onClick={onCancel}
              size="medium"
              sx={{ fontWeight: buttonFontWeight }}
              type="button"
              variant="text"
            >
              NO
            </Button>
          </Stack>
        }
        icon={false}
        id={id}
        severity="warning"
        sx={{ alignItems: 'center', mb: 2, width: '100%' }}
        variant="filled"
      >
        {OFFLINE_PUNCH_DELETE_CONFIRM_MESSAGE}
      </Alert>
    </Collapse>
  );
}

OfflinePunchDeleteConfirmAlert.propTypes = {
  id: PropTypes.string.isRequired,
  isDeleting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default React.memo(OfflinePunchDeleteConfirmAlert);
